class StartNewQuote {
    constructor($state, $scope, UserService, $stateParams) {
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$scope.canCreateSubmission = false;
        const permissionDTO = {
            permission: 'createsubmission'
        };

        UserService.hasUserSystemPermission(permissionDTO).then((canCreateSubmission) => {
            this.$scope.canCreateSubmission = canCreateSubmission;
        });
    }

    isOnAccountViewState() {
        return this.$state.includes('accounts.detail');
    }

    checkCreateSubmissionPermission() {
        return this.$scope.canCreateSubmission;
    }

    getAccountNumberFromStateParams() {
        return this.$stateParams.accountNumber;
    }
}

StartNewQuote.$inject = ['$state', '$scope', 'UserService', '$stateParams'];

export default StartNewQuote;

